/**
 * @description 删除字符串左右两端的半角空格
 * @param str
 * @returns string
 */
function trim (str) {
    if (str !== null && str !== '' && str !== undefined) {
        return str.replace(/(^ *)|( *$)/gi, '')
    } else {
        return str
    }
}

/**
 * 判断 Vuex.store中参数缓存是否清空
 * @param  toUrl
 */
function checkUrl (fromUrl) {
    const array = []
    array.push('dashboard')
    array.push('course-management')
    array.push('test-paper-release')
    array.push('teach-team')
    array.push('class-management')
    array.push('major-management')
    array.push('permission-management-public')
    array.push('course_file')
    array.push('course_homework')
    array.push('course_lesson')
    array.push('organization-management')
    array.push('operation-log-public')
    if (array.indexOf(fromUrl) !== -1) {
        // 是从菜单跳过来的
        return 'true'
    } else if (fromUrl === null) {
        // 自身页面刷新时
        return 'true'
    } else {
        return 'false'
    }
}

function saveStorage (store) {
    if (sessionStorage.getItem('store')) {
      store.replaceState(
        Object.assign(
          {},
          store.state,
          JSON.parse(sessionStorage.getItem('store')),
        ),
      )
      sessionStorage.removeItem('store')
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
/**
 * 上传多个文件
 * @param {*} file 文件
 * @param {*} type 上传类型
 * @param {*} length 上传最多文件个数
 */
function checkFilesUpload (file, type, length) {
  var fileList = {
    fileName: '',
    extension: '',
    length: '',
    snackbarText: '',
   }
   // 当前上传文件个数
   fileList.length = file.length
  // 当没有选择文件时直接返回
  if (fileList.length === 0) {
    return
  }
  // 当选中的文件个数大于上传最多个数
  if (fileList.length > length) {
    fileList.snackbarText = '最多只能选择' + length + '个文件！'
    return fileList
  } else {
    // 当选中的文件个数小于上传最多个数
    for (var i = 0; i < fileList.length; i++) {
    // 获取文件名
      fileList.fileName = file[i].name
      // 获取文件名后缀
      console.log('后缀', fileList.extension)
      fileList.extension = fileList.fileName.substring(fileList.fileName.lastIndexOf('.') + 1)
        if (type === 'img') {
          // 当类型是图片时
          if (fileList.extension !== 'jpg' && fileList.extension !== 'jpeg' && fileList.extension !== 'png' &&
            fileList.extension !== 'JPG' && fileList.extension !== 'JPEG' && fileList.extension !== 'PNG') {
            fileList.snackbarText = '只能上传.jpg，.jpeg，.png为后缀的图片！'
            //file.target.value = ''
            return fileList
          }
        }
        if (type === 'pdf') {
          // 当类型是pdf时
          if (fileList.extension !== 'jpg' && fileList.extension !== 'jpeg' && fileList.extension !== 'png' &&
            fileList.extension !== 'JPG' && fileList.extension !== 'JPEG' && fileList.extension !== 'PNG' &&
            fileList.extension !== 'pdf' && fileList.extension !== 'PDF') {
            fileList.snackbarText = '只能上传.jpg，.jpeg，.png，.pdf为后缀的文件！'
            //file.target.value = ''
            return fileList
          }
        }
        if (type === 'video') {
          // 当类型是视频时
          if (fileList.extension !== 'mp4') {
            fileList.snackbarText = '只能上传.mp4为后缀的视频！'
            //file.target.value = ''
            return fileList
          }
        }
        if (type === 'audio') {
          // 当类型是音频时
          if (fileList.extension !== 'mp3') {
            fileList.snackbarText = '只能上传.mp3为后缀的音频！'
            //file.target.value = ''
            return fileList
          }
        }
        console.log('文件大小', file[i].size)
        if (type === 'img' && file[i].size > 1048576*10) {
          // 当文件大于1mb时
          fileList.snackbarText = '单个文件必须小于10MB。'
          //file.target.value = ''
          return fileList
        }
        if (type === 'video' && file[i].size > 1048576*1024) {
          // 当文件大于1gb时
          fileList.snackbarText = '单个视频文件必须小于1GB。'
          //file.target.value = ''
          return fileList
        }
        if (type === 'audio' && file[i].size > 1048576*500) {
          // 当文件大于500mb时
          fileList.snackbarText = '单个音频文件必须小于500MB。'
          //file.target.value = ''
          return fileList
        }
     }
  }
  return fileList
}

/**
 * check单个上传文件类型
 * @param {*} file 文件
 * @param {*} type 类型
 */
function fileUploadCheck (file, type) {
  var fileList = {
    fileName: '',
    extension: '',
    snackbarText: '',
   }
  // 当没有选择文件时直接返回
  if (file === "" || file === null || file === undefined) {
    return
  }
  // 获取文件名
  fileList.fileName = file.name
  // 获取文件名后缀
  fileList.extension = fileList.fileName.substring(fileList.fileName.lastIndexOf('.') + 1)
  if (type === 'img') {
    // 当类型是图片时
    if (fileList.extension !== 'jpg' && fileList.extension !== 'jpeg' && fileList.extension !== 'png' &&
      fileList.extension !== 'JPG' && fileList.extension !== 'JPEG' && fileList.extension !== 'PNG') {
      fileList.snackbarText = '只能上传.jpg，.jpeg，.png为后缀的图片！'
      return fileList
    }
  }
   if (type === 'pdf') {
    // 当类型是pdf时
    if (fileList.extension !== 'pdf' && fileList.extension !== 'PDF' &&
    fileList.extension !== 'jpg' && fileList.extension !== 'jpeg' && fileList.extension !== 'png' &&
    fileList.extension !== 'JPG' && fileList.extension !== 'JPEG' && fileList.extension !== 'PNG') {
      fileList.snackbarText = '只能上传.jpg，.jpeg，.png，.pdf为后缀的文件！'
      return fileList
    }
  }
  if (type === 'audio') {
    // 当类型是音频时
    if (fileList.extension !== 'mp3') {
      fileList.snackbarText = '只能上传.mp3为后缀的音频！'
      return fileList
    }
  }
  if(type === 'apk'){
    // 当类型是音频时
    if (fileList.extension !== 'apk') {
      fileList.snackbarText = '只能上传.apk为后缀的安装包！'
      return fileList
    }
  }
  if (type === 'file') {
    // 当类型是文件时
    var fileName = file.name;
    var fiex = fileName.substring(
      fileName.lastIndexOf(".") + 1,
      fileName.length
    );
    var newFileFiexs = "doc,pdf,docx,xls,xlsx,ppt,pptx,DOC,PDF,DOCX,XLS,XLSX,PPT,PPTX";
    if (newFileFiexs.indexOf(fiex) < 0) {
      fileList.snackbarText = "只能上传word/pdf/excel/ppt文件！"
      return fileList
    }
    if (file.length > 45) {
      fileList.snackbarText = "文件名长度不能超过45位！"
      return fileList
    }
  }

  if (type === 'img' && file.size > 1048576*5) {
      // 当文件大于1mb时
      fileList.snackbarText = '文件必须小于5MB。'
      return fileList
  }
  if (type === 'video' && file.size > 1048576*1024) {
    // 当文件大于1gb时
    fileList.snackbarText = '单个视频文件必须小于1GB。'
    //file.target.value = ''
    return fileList
  }
  if (type === 'audio' && file.size > 1048576*500) {
    // 当文件大于500mb时
    fileList.snackbarText = '单个音频文件必须小于500MB。'
    //file.target.value = ''
    return fileList
  }
  if (type === 'file' && file.size > 1048576*500) {
    // 当文件大于500mb时
    fileList.snackbarText = '单个资料文件必须小于500MB。'
    //file.target.value = ''
    return fileList
  }
  if (type === 'apk' && file.size >  1048576*10) {
    // 当文件大于10mb时
    fileList.snackbarText = '单个文件必须小于10MB。'
    //file.target.value = ''
    return fileList
  }
  return fileList
}

/**
 * 身份证check
 * @param {*} id
 */
function checkIdCardNo (id) {
  var regIdNo = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
  var regAge = /(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229)$/
  // 格式check
  if (!regIdNo.test(id) || !regAge.test(id.substring(6, 14))) {
    return false
  } else {
    // 年龄check
    const age = String(id).substring(6, 10)
    if (age !== null && age !== undefined && age !== '') {
      const val = new Date().getFullYear() - Number(age)
      if (val <= 0 || val > 150) {
        return false
      } else {
        return true
      }
    }
  }
}

/**
 * 电话号校验
 * @param {电话号} tel 
 */
function checkTelNo (tel) {
  if (/^1[3456789]\d{9}$/.test(tel) == true) {
    return true
  } else {
    return false
  }
}

/**
 * 根据身份证号取得性别
 * @param {电话号} idCardNo 
 */
function getSexByIdCardNo (idCardNo) {
  var sexType = ''
  if(checkIdCardNo(idCardNo)) {
    var sex = idCardNo.substring(16, 17)
    // 性别
    if (sex % 2 === 0) {
      sexType = '02'
    } else {
      sexType = '01'
    }
  }
  return sexType
}

/**
 * 根据身份证号取得年龄
 * @param {电话号} idCardNo 
 */
function getAgeByIdCardNo (idCardNo) {
  var age = ''
  if(checkIdCardNo(idCardNo)) {
    // 年龄
    const ageStr = String(idCardNo).substring(6, 10)
    age = new Date().getFullYear() - Number(ageStr)
  }
  return age.toString()
}

export default {
    trim,
    checkUrl,
    saveStorage,
    checkFilesUpload,
    fileUploadCheck,
    checkIdCardNo,
    checkTelNo,
    getSexByIdCardNo,
    getAgeByIdCardNo,
}
